import * as TYPES from './types'

export default {
  [TYPES.SET_THEMES] (state, themes) {
    if (themes && Array.isArray(themes)) {
      Vue.set(state, 'themes', themes)
    }
  },
  [TYPES.ADD_THEME] (state, theme) {
    state.themes.push(theme)
  },
  [TYPES.REMOVE_THEME] (state, themeId) {

  },
  [TYPES.RESET_THEMES] (state) {
    Vue.set(state, 'themes', [])
  },
  [TYPES.SET_CURRENT_THEME] (state, theme) {
    Vue.set(state, 'currentTheme', theme)
  },
  [TYPES.RESET_CURRENT_THEME] (state) {
    Vue.set(state, 'currentTheme', null)
  },
  [TYPES.HYDRATE_THEME_WITH_SHOPIFY](state, { masterclassId, shopifyId }) {
    let ind = state.themes.findIndex(el => el && el.id === masterclassId)
    if (ind > -1 && !state.themes[ind].shopifyIds.includes(shopifyId)) {
      state.themes[ind].shopifyIds.push(shopifyId)
    }
  }
}
